// export const demoForCarModelIds = [37, 48]; // 37 特斯拉 48 小米
export const polygonZoom = [13, 20];


// 本品牌门店-海量点-600
// 踩点、打靶-海量点-590
// 后200名是海量点-580
// 其他品牌门店（竞品、知名品牌）：海量点-570

// 卡片-marker-200
// 开店区域排名/名称  排名：前两百名是Marker，名称：放大后的名称Marker-190
export const mapZIndex = {
  // 海量点-Mass
  ownBrand: 600, // 本品牌门店
  treadRecord: 590, // 踩点
  fixedPoint: 590, // 打靶
  businessAreaMass: 580, // 开店区域排名/名称
  competitorBrand: 570, // 竞品品牌门店
  famousBrand: 570, // 知名品牌门店

  // Marker
  activeFrom: 220, // 活动表单,
  rightOperate: 210, // 操作栏
  hoverCard: 200, // 卡片
  businessArea: 190, // 开店区域排名/名称
};
// 缩放级别到17时，显示可视区域内所有的开店区域名称
export const showViewAreaNameZoom = 17;

// export const categoriesEnum = {
//   1: '商业街',
//   2: '商业体',
//   3: '文教型',
//   4: '复合型',
//   5: '景区型',
//   6: '办公型',
//   7: '医疗保健',
//   8: '社区型'
// };

const hasValueCount = (data: any) => {
  const values = Object.values(data || {});
  let count = 0;
  values.forEach((valueItem: any) => {
    valueItem && count++;
  });
  return count;
};

export const getTargetDynamicHeight = (value: any) => {
  const height = 52; // 默认值(标题高度)
  const {
    openTypeName,
    statusName,
    typeName,
    function: func, // 重命名
    address,
    modelClusterName,
  } = value || {};
  const count = hasValueCount({
    openTypeName,
    statusName,
    typeName,
    func,
    address,
    modelClusterName
  });
  return height + count * 28;
};

export const checkInFieldAFormContainer = 'checkInFieldAFormContainer';
